var map = {
	"./affiliate_icon.png": 34678,
	"./announcement_speaker.png": 72049,
	"./arrow.png": 74931,
	"./arrow_shape.png": 95951,
	"./autopool_modal_bg.png": 30837,
	"./autopool_modal_bg1.png": 79814,
	"./autopool_modal_bg2.png": 51272,
	"./autopool_modal_bg3.png": 7184,
	"./autopoolbg.png": 62153,
	"./autopoolbg_noshadow.png": 56707,
	"./b1.png": 33936,
	"./b2.png": 81244,
	"./b3.png": 12463,
	"./ba-bullet.png": 80983,
	"./banner_bottom_img.png": 64787,
	"./banner_gif.gif": 21353,
	"./banner_img.png": 15758,
	"./banner_logo_new.png": 97241,
	"./banner_top_img.png": 11167,
	"./bg_shape_01.png": 91784,
	"./bg_shape_02.png": 60129,
	"./bgimg.png": 5432,
	"./bnjr_token.png": 78168,
	"./bonjur_logo.png": 95301,
	"./bonjure-popup-logo.png": 82837,
	"./bonjure-popup-right.png": 15378,
	"./btnimg.png": 34606,
	"./circle.svg": 91858,
	"./circle_bg.png": 41750,
	"./claim_icon.png": 44353,
	"./close-icon.png": 19638,
	"./close_icon.png": 82790,
	"./close_icon.svg": 66644,
	"./coming_soon.png": 11399,
	"./copy_icon.png": 77797,
	"./d1.png": 75960,
	"./d2.png": 99385,
	"./d3.png": 59053,
	"./d4.png": 21736,
	"./d5.png": 29720,
	"./d6.png": 11198,
	"./d7.png": 54220,
	"./d8.png": 16632,
	"./d9.png": 16576,
	"./dash_icon_01.png": 85246,
	"./dash_icon_02.png": 44079,
	"./dash_icon_03.png": 38828,
	"./dash_icon_04.png": 69897,
	"./dash_shade.png": 97862,
	"./faq_shade.png": 52343,
	"./footer_after.png": 96546,
	"./footer_before.png": 69417,
	"./heading_after.png": 89481,
	"./heading_before.png": 69421,
	"./icon_01.png": 10405,
	"./icon_02.png": 65320,
	"./icon_03.png": 20302,
	"./icon_05.png": 20597,
	"./icon_06.png": 25570,
	"./image_2023_05_12T12_04_11_186Z-(1).jpg": 21044,
	"./inner_shadow.svg": 38046,
	"./join_now_icon.png": 5719,
	"./left-sparkles.png": 88906,
	"./line_shape.png": 26765,
	"./list_arrow.png": 20124,
	"./logo.png": 74427,
	"./logo.svg": 82835,
	"./logo_1.png": 8788,
	"./logo_large.png": 95239,
	"./logout_btn.png": 23099,
	"./madel_01.png": 3157,
	"./madel_02.png": 626,
	"./madel_03.png": 2433,
	"./madel_04.png": 9632,
	"./madel_05.png": 31118,
	"./madel_06.png": 24523,
	"./madel_07.png": 36537,
	"./madel_08.png": 54846,
	"./madel_09.png": 28269,
	"./madel_10.png": 58585,
	"./madel_starter.png": 51319,
	"./map_bg.png": 69048,
	"./medal_01.png": 3543,
	"./metamask.png": 58843,
	"./minus_icon.png": 28788,
	"./new_dash_icon_01.png": 7298,
	"./new_dash_icon_02.png": 23084,
	"./new_dash_icon_03.png": 44534,
	"./new_dash_icon_04.png": 52451,
	"./nfc_card.png": 45719,
	"./one.png": 53008,
	"./onedollarplan/b1.png": 40278,
	"./onedollarplan/b2.png": 30209,
	"./onedollarplan/b3.png": 95142,
	"./onedollarplan/b4.png": 15132,
	"./onedollarplan/bgimg.png": 82129,
	"./onedollarplan/claim_boxbg.png": 60546,
	"./onedollarplan/copy.png": 53241,
	"./onedollarplan/img_shade.png": 99137,
	"./onedollarplan/l1.png": 5097,
	"./onedollarplan/l2.png": 2258,
	"./onedollarplan/l3.png": 11181,
	"./onedollarplan/left_boxbg.png": 86919,
	"./onedollarplan/one.png": 65882,
	"./onedollarplan/one1.png": 35811,
	"./plus_icon.png": 80824,
	"./poolimg.png": 11858,
	"./pop_img.png": 33833,
	"./popup_img.png": 1585,
	"./popup_img00.png": 66081,
	"./popup_img1.png": 84798,
	"./popup_v2.png": 93839,
	"./popup_v3.png": 39862,
	"./popupimg_mob.png": 49229,
	"./popupimg_mob_blw.png": 7442,
	"./portis.png": 98668,
	"./qr.jpg": 52230,
	"./reinvest_icon.png": 42660,
	"./s_anime.gif": 23822,
	"./seemore_arw.png": 7469,
	"./seemore_arw1.png": 17198,
	"./slick_nxt.png": 5671,
	"./slick_prev.png": 65507,
	"./slider_user.png": 71181,
	"./slider_wallet.png": 70550,
	"./speaker.png": 26155,
	"./three.png": 34797,
	"./torus.png": 51111,
	"./trans.png": 69676,
	"./tree_icon.png": 7338,
	"./tree_structure.png": 15088,
	"./tree_user_id.png": 38371,
	"./trustwallet.png": 89414,
	"./two.png": 49924,
	"./user_prf.png": 85528,
	"./wallet.png": 82106,
	"./wallet_icon.png": 39073,
	"./walletconnect.png": 16354,
	"./world_map.png": 51684
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90990;